import { AxiosInstance } from 'axios';

export const dataProviderStateMock = {
  client: null as unknown as AxiosInstance,
};
